const permissions = {
MRRReports:1,
MRRInitial:2,
MRRQA:3,
MRRInprogress:4,
MRRReviewCancel:5,
MRRMedicalDirector:6,
MRRCompleted:7,
MRRCoderQA:8,
AdministrationAccess:9,
ClaimsRecyclingButton:10,
EMRDocumentAdmin:11,
PECCDIAlerts:12,
PECPackages:13,
PECPracticeType:14,
PECFaxValidation:15,
PECPracticeInfo:16,
RiskMitigation:17,  // This permission is not available in API
PreExtractQAButton:18, // This permission is not available in API
EMRAdmin:19,  // This permission is not available in API
CodingManagerAdmin:20, // This permission is not available in API
ScanRosterTab:21// This permission is not available in API
};
Object.freeze(permissions);
export const Permissions = permissions;